import React from 'react'
import Ctalogo from '../../../assets/images/gurpeet.jpg';
import { Link } from 'react-router-dom';

const Ctaone = () => {
    return (
        <section className="cta-one" style={{ paddingTop: 24 }}>
            <div className="container">
                <div className="text-center mb-4" style={{ marginTop: 32 }}>
                    <h1 style={{ fontWeight: 500, fontSize: '2.5rem', marginBottom: 0 }}>
                       
                    
                    </h1>
                <div>    
                    {/* <div style={{
                        width: 170,
                        margin: '12px auto 0 auto',
                        borderBottom: '2px solid #222',
                        position: 'relative',
                        height: 24,
                        display: 'inline',
                    }}/>
                        <span style={{
                            display: 'inline',
                            position: 'absolute',
                            left: '50%',
                            top: -16,
                            transform: 'translateX(-50%)',
                            background: '#fff',
                            padding: '0 12px',
                            fontSize: 24,
                            letterSpacing: 8
                        }}>
                            ★★★
                        </span>
                        <div style={{
                        width: 170,
                        margin: '12px auto 0 auto',
                        borderBottom: '2px solid #222',
                        position: 'relative',
                        height: 24,
                        display: "inline"
                    }}/> */}
                    
                    
                </div>    
                </div>
                <div className="row justify-content-center align-items-start" style={{ marginTop: 34 }}>
                    <div className="col-lg-7 col-md-8 col-12 px-4" style={{ textAlign: 'left' }}>
                        <div style={{ fontSize: 18, lineHeight: 1.7, maxWidth: 700 }}>
                            <p className='mb-3'>
                                <span style={{ fontWeight: 600, fontSize: 22 }}>Dear friends,</span>
                            </p>
                            <p style={{ textAlign: "justify"}}>
                            In today’s fast-moving global environment, NRIs need more than just advice—they need a trusted partner who understands complexity and delivers with precision. At The NRI Advisors, we proudly offer U.S.-based leadership with global expertise, combining legal insight and business strategy to handle your most critical cross-border matters. Whether you are planning your estate, securing your assets, or navigating complex documentation, our team is committed to making the process simple, clear, and fully aligned with your goals.
                            </p>
                            <p style={{ textAlign: "justify"}}>
                            We understand the challenges NRIs face while managing affairs from afar. That’s why we focus on clarity, consistency, and care, ensuring you feel confident and supported at every step. Thank you for trusting us to guide you through your global journey.
                            </p>
                            
                            
                            <p style={{ fontWeight: 600, marginTop: 32, marginBottom: 0 }}>
                                Warm regards,<br />
                                Gary S. Pasricha<br />
                                <span style={{ fontWeight: 400 }}>Head – U.S. Operations, The NRI Advisors</span>
                            </p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-10 d-flex justify-content-center" style={{ minWidth: 320 }}>
                        <img
                            src={Ctalogo}
                            alt="Vivek Aggarwal"
                            style={{
                                width: 420,
                                height: 420,
                                objectFit: 'cover',
                                borderRadius: 4,
                                marginLeft: 24,
                                boxShadow: '0 2px 16px rgba(0,0,0,0.08)'
                            }}
                        />
                    </div>
                </div>
            </div>
        </section>
    )
}
export default Ctaone;